import React from 'react';

function Container({ classe, children }) {
    return (
        <div className={`max-w-7xl h-full mx-auto px-5 md:px-6 lg:px-5 ${ classe }`}>
            { children }
        </div>
    );
}

export default Container;